module.exports = __webpack_public_path__ + "img/5_no.0294b012.svg";